module.exports = __webpack_public_path__ + "media/images/ui__burgerButton-fcdf4e5892de716ff8c3734cd70b733a.svg";